module.exports = __webpack_public_path__ + "static/img/jdd-qpd-dk.d4e91d7d.png";